import ability from './ability'

export const canNavigate = (to, appAbility = null) => {
    if(appAbility !== null) return to.matched.some(route => appAbility.can(route.meta.action || 'read', route.meta.resource));
    return to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.resource));
}


export const _ = undefined
